<template>
  <div>
    <div class="columns">
      <div class="map">
        <gmap-map
          :center="address"
          :zoom="zoomCarto"
          :options="mapOptions"
          class="googleMap"
          @click="close()" ref="map">
          <gmap-cluster :minimumClusterSize="minClusterSize"
            zoomOnClick @click="autoZoom">
            <gmap-marker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="m.clickable"
              :draggable="false"
              :icon="m.icon"
              @click="center=m.position, updateDistance(m), openModal()">
            </gmap-marker>
          </gmap-cluster>
          <gmap-marker v-for="concurrent in concurrentsFiltres"
                      :key="concurrent.id"
                      :position="concurrent.position"
                      :clickable="false"
                      :draggable="false"
                      :icon="concurrent.icone"
          >
          </gmap-marker>
          <gmap-marker v-for="(point, i) in markersPoint"
                      :key="i+point.libelle"
                      :position="point.coordonnees"
                      :clickable="false"
                      :draggable="false"
                      :icon="point.icon"
          >
          </gmap-marker>
          <gmap-marker
            key="test"
            :position="address"
            :clickable="false"
            :draggable="false"
            :icon=puceNoire>
            </gmap-marker>
          <gmap-circle v-if="affichageCercle" :bounds="circleBounds"
                        :center="address"
                        :radius="rayon*1000" :options=optionCircle
                        @radius_changed="updateCircle('radius', $event)"
                        @bounds_changed="updateCircle('bounds', $event)">
          </gmap-circle>
          <gmap-circle :bounds="circleBounds"
                      v-for="(point, i) in cerclePoints"
                      :key="i+point.libelle"
                      :center="point.coordonnees"
                      :radius="rayon*1000" :options=optionCircle
                      @radius_changed="updateCircle('radius', $event)"
                      @bounds_changed="updateCircle('bounds', $event)">
          </gmap-circle>
        </gmap-map>
        <b-modal v-model="isComponentDetailFacesLc"
                has-modal-card
                class="modal">
          <app-info-window-map v-bind:marker="selectedMarker"
                              @closeInfoWindow="selectedMarker=''"/>
        </b-modal>
      </div>
    </div>
    <app-statistiques-geo-marketing
      :address="address"
      :isochrone="isochrone"
      :typeLayerGeoMarketing="typeLayerGeoMarketing" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { getMapGeoJson } from '@/api/asterop';
import { getConcurrents, overrideStyle } from '@/services/asterop/mapHelper';
import * as types from '@/store/creationOpportunite/venteNumerique-mutation-type';
import statistiquesGeoMarketing from '@/components/general/statistiquesGeoMarketing';
import { MARKER_POINT_NOIR, OPTION, MINIMUM_CLUSTER_SIZE,
  TYPE_LAYER_EMPTY, TYPE_LAYER_GEO_MARKETING_CONCU, STYLE_MAPS_POI_HIDDEN, MAP_TYPE_CONTROL_OPTIONS, MAP_TYPE_NAME } from '@/configuration/carteConf';
import InfoWindowMap from './cartographie/infoWindowMap';

const Numerique = createNamespacedHelpers('venteNumerique');
const User = createNamespacedHelpers('user');
const Parametrage = createNamespacedHelpers('parametrage');

export default {
  name: 'app-map',
  data() {
    return {
      circleBounds: '',
      optionCircle: OPTION,
      minClusterSize: MINIMUM_CLUSTER_SIZE,
      isComponentDetailFacesLc: false,
      layerGeoMarketting: false,
      concurrents: [],
      mapOptions: {
        mapTypeControlOptions: MAP_TYPE_CONTROL_OPTIONS,
      },
    };
  },
  components: {
    appInfoWindowMap: InfoWindowMap,
    appStatistiquesGeoMarketing: statistiquesGeoMarketing,
  },
  computed: {
    ...Numerique.mapGetters({
      markers: 'markers',
      rayon: 'rayon',
      address: 'address',
      isochrone: 'isochrone',
      typeLayerGeoMarketing: 'typeLayerGeoMarketing',
      panneauxWithFilter: 'panneauxWithFilter',
      affichageCercle: 'affichageCercle',
      getSelectedMarker: 'selectedMarker',
      getZoomCarto: 'zoomCarto',
      getPointsAddress: 'pointsAddress',
    }),
    ...User.mapGetters({
      hasGeoMarketing: 'hasGeoMarketing',
    }),
    ...Parametrage.mapGetters({
      symboles: 'symboles',
    }),
    selectedMarker: {
      get() {
        return this.getSelectedMarker;
      },
      set(value) {
        this.setSelectedMarker(value);
      },
    },
    zoomCarto: {
      get() {
        return this.getZoomCarto;
      },
      set(value) {
        this.setZoomCarto(value);
      },
    },
    cerclePoints() {
      if (!this.affichageCercle) return [];
      return this.markersPoint;
    },
    puceNoire() {
      if (this.address !== null && Object.prototype.hasOwnProperty.call(this.address, 'urlLogo')) {
        const h = 40;
        let w = h;
        const img = new Image();
        img.src = this.address.urlLogo;
        if (img.height > 0) {
          w = img.width / (img.height / h);
        }
        const icon = {
          url: this.address.urlLogo,
          scaledSize: { width: w, height: h, f: 'px', b: 'px' },
        };
        return icon;
      }


      if (this.address !== null && Object.prototype.hasOwnProperty.call(this.address, 'symbole') &&
        this.symboles &&
        Object.prototype.hasOwnProperty.call(this.symboles, this.address.symbole)) {
        const icon = {
          url: this.symboles[this.address.symbole],
          size: { width: 50, height: 50, f: 'px', b: 'px' },
          scaledSize: { width: 50, height: 50, f: 'px', b: 'px' },
        };
        return icon;
      }
      return MARKER_POINT_NOIR;
    },
    concurrentsFiltres() {
      if (this.address !== null && Object.prototype.hasOwnProperty.call(this.address, 'codeType')) {
        const tmp = this.concurrents.filter(c =>
          c.codeType === this.address.codeType && c.icone);
        tmp.forEach((element) => {
          if (element.position.lat !== this.address.lat
            && element.position.lng !== this.address.lng) {
            element.icone = {
              url: element.icone,
              size: { width: 20, height: 20, f: 'px', b: 'px' },
              scaledSize: { width: 20, height: 20, f: 'px', b: 'px' },
            };
          }
        });
        return tmp;
      }
      this.concurrents.forEach((element) => {
        if (element.position.lat !== this.address.lat
          && element.position.lng !== this.address.lng) {
          element.icone = {
            url: element.icone,
            size: { width: 20, height: 20, f: 'px', b: 'px' },
            scaledSize: { width: 20, height: 20, f: 'px', b: 'px' },
          };
        }
      });
      return this.concurrents;
    },
    markersPoint() {
      return this.getPointsAddress;
    },
  },
  watch: {
    async isochrone() {
      await this.updateLayer();
    },
    async address() {
      await this.updateLayer();
    },
    async typeLayerGeoMarketing() {
      await this.updateLayer();
    },
    markersPoint() {
      this.autoZoom();
    },
  },
  methods: {
    ...Numerique.mapMutations({
      setSelectedMarker: types.SET_SELECTED_MARKER,
      setZoomCarto: types.SET_ZOOM_CARTO,
    }),
    ...Parametrage.mapActions({
      actionsLoadSymboles: 'loadSymboles',
    }),
    updateCircle(prop, value) {
      if (prop === 'radius') {
        this.radius = value;
      } else if (prop === 'bounds') {
        this.circleBounds = value;
      }
    },
    updateDistance(marker) {
      this.selectedMarker = marker;
    },
    updateZoom($event) {
      this.zoomCarto = $event;
    },
    close() {
      if (this.selectedMarker) {
        this.selectedMarker = '';
      }
    },
    openModal() {
      this.updateDistanceInfoWindow();
    },
    computeTotalDistance(directions) {
      if (!directions || !directions.routes || directions.routes.length === 0) {
        this.isComponentDetailFacesLc = true;
        return;
      }

      let total = 0;
      const myroute = directions.routes[0];
      for (let i = 0; i < myroute.legs.length; i += 1) {
        total += myroute.legs[i].distance.value;
      }
      this.selectedMarker.distance = Math.round(total / 10) / 100;
      this.isComponentDetailFacesLc = true;
    },
    updateDistanceInfoWindow() {
      if (this.selectedMarker.distance != null) {
        this.isComponentDetailFacesLc = true;
        return;
      }

      const positionCentre = new google.maps.LatLng(this.address.lat, this.address.lng);
      const positionMarker = new google.maps.LatLng(this.selectedMarker.position.lat,
        this.selectedMarker.position.lng);
      const directionsDisplay = new google.maps.DirectionsRenderer();

      const request = {
        origin: positionCentre,
        destination: positionMarker,
        travelMode: google.maps.DirectionsTravelMode.DRIVING,
      };
      const directionsService = new google.maps.DirectionsService();
      directionsService.route(request, (response, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          directionsDisplay.setDirections(response);
          this.computeTotalDistance(directionsDisplay.getDirections());
        }
      });
    },
    async updateLayer() {
      // Largement inspiré de
      // https://stackoverflow.com/questions/50496101/remove-google-map-geojson-polygon
      // https://developers.google.com/maps/documentation/javascript/datalayer
      const map = await this.$refs.map.$mapPromise;
      this.concurrents = [];
      if (this.layerGeoMarketting && this.layerGeoMarketting.setMap) {
        this.layerGeoMarketting.setMap(null);
      }
      if (!this.address ||
          !this.hasGeoMarketing ||
          this.typeLayerGeoMarketing === TYPE_LAYER_EMPTY) {
        return;
      }
      this.layerGeoMarketting = new google.maps.Data({
        map: map,
      });

      const response = await getMapGeoJson(this.typeLayerGeoMarketing, this.address,
        this.isochrone);
      if (this.typeLayerGeoMarketing === TYPE_LAYER_GEO_MARKETING_CONCU) {
        this.concurrents = await getConcurrents(this.address,
          this.isochrone, 1, this.symboles);
      }
      const geoJson = response.data;
      const styles = geoJson.style;

      this.layerGeoMarketting.addGeoJson(geoJson);
      this.layerGeoMarketting.setStyle((feature) => {
        return overrideStyle(feature, styles);
      });
    },
    autoZoom() {
      if (this.$refs.map !== undefined) {
        this.$refs.map.$mapPromise.then(() => this.fitBounds());
      }
    },
    fitBounds() {
      const latlngbounds = new google.maps.LatLngBounds();
      for (let i = 0; i < this.markers.length; (i += 1)) {
        latlngbounds.extend(this.markers[i].position);
      }
      for (let i = 0; i < this.getPointsAddress.length; (i += 1)) {
        latlngbounds.extend(this.getPointsAddress[i].coordonnees);
      }
      for (let i = 0; i < this.concurrentsFiltres.length; (i += 1)) {
        latlngbounds.extend(this.concurrentsFiltres[i].position);
      }
      latlngbounds.extend(this.address);
      this.$refs.map.fitBounds(latlngbounds);
    },
    async initPoi() {
      const map = await this.$refs.map.$mapPromise;
      const styleMap = new google.maps.StyledMapType(
        STYLE_MAPS_POI_HIDDEN,
        { name: MAP_TYPE_NAME },
      );
      map.mapTypes.set('styled_map', styleMap);
    },
  },
  async mounted() {
    if (this.$refs.map !== undefined) {
      this.$refs.map.$mapPromise.then(() => this.fitBounds());
      await this.initPoi();
    }
    if (this.hasGeoMarketing) {
      await this.updateLayer();
      await this.actionsLoadSymboles();
    }
  },
};

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/recherche/carte.vue